// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6mQyU6NVx{box-shadow:0px 1px 2px 0px rgba(0,0,0,0.2);border-radius:25%}@media screen and (-ms-high-contrast: active){._6mQyU6NVx{border:1px solid windowText;box-sizing:border-box}}._4f8phWTox{display:inline-flex}._2HagqVGRx{border-radius:20%;-webkit-mask-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY1IDBjMTAuMiAwIDE1LjIgMCAyMC42IDEuN0M5MS42IDQgOTYgOC41IDk4LjMgMTQuNCAxMDAgMTkuOCAxMDAgMjQuOCAxMDAgMzV2MzBjMCAxMC4yIDAgMTUuMi0xLjcgMjAuNi0yLjIgNi02LjggMTAuNS0xMi43IDEyLjdDODAuMiAxMDAgNzUuMiAxMDAgNjUgMTAwSDM1Yy0xMC4yIDAtMTUuMiAwLTIwLjYtMS43QzguNCA5NiA0IDkxLjUgMS43IDg1LjYgMCA4MC4yIDAgNzUuMiAwIDY1VjM1YzAtMTAuMiAwLTE1LjIgMS43LTIwLjZDNCA4LjQgOC41IDQgMTQuNCAxLjcgMTkuOCAwIDI0LjggMCAzNSAwaDMweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+\");mask-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY1IDBjMTAuMiAwIDE1LjIgMCAyMC42IDEuN0M5MS42IDQgOTYgOC41IDk4LjMgMTQuNCAxMDAgMTkuOCAxMDAgMjQuOCAxMDAgMzV2MzBjMCAxMC4yIDAgMTUuMi0xLjcgMjAuNi0yLjIgNi02LjggMTAuNS0xMi43IDEyLjdDODAuMiAxMDAgNzUuMiAxMDAgNjUgMTAwSDM1Yy0xMC4yIDAtMTUuMiAwLTIwLjYtMS43QzguNCA5NiA0IDkxLjUgMS43IDg1LjYgMCA4MC4yIDAgNzUuMiAwIDY1VjM1YzAtMTAuMiAwLTE1LjIgMS43LTIwLjZDNCA4LjQgOC41IDQgMTQuNCAxLjcgMTkuOCAwIDI0LjggMCAzNSAwaDMweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+\");-webkit-mask-size:100%;mask-size:100%}._4I6TcesIx{border-radius:10%}._6t3TDmILx{border-radius:10%}._6nK6vB8vx{background:#0075DA;border-radius:10%}._2RVDqEpPx{background:#fff;border-radius:10%}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"app": "_6mQyU6NVx",
	"os-icon": "_4f8phWTox",
	"osIcon": "_4f8phWTox",
	"ios": "_2HagqVGRx _4f8phWTox",
	"macos": "_4I6TcesIx _4f8phWTox",
	"android": "_6t3TDmILx _4f8phWTox",
	"windows": "_6nK6vB8vx _4f8phWTox",
	"generic": "_2RVDqEpPx _4f8phWTox"
};
module.exports = exports;
